import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc, where, limit, getAggregateFromServer, sum, getCountFromServer } from 'firebase/firestore'
import moment from 'moment';

export default function ExiseReport() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });
  const [userData, setUserData] = useState();
  const [productCat, setproductCat] = useState([]);
  const [searchText, setsearchText] = useState("");
  const [products, setproducts] = useState([]);
  const [exisereports, setexisereports] = useState([]);
  const [reportData, setreportData] = useState([]);
  const [date, setdate] = useState("");
  const [reportdate, setreportdate] = useState("");

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setdate(formattedDate);
    if (searchText === '') {
      fetchData1()
    } else {
      fetchData2()
    }


  }, [searchText]);



  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
    });
  });

  const fetchData1 = async () => {
    try {
      // 1. Fetch excise reports (real-time)
      const q = query(collection(db, 'excisereport'), orderBy("created", "desc"));
      onSnapshot(q, (querySnapshot) => {
        setexisereports(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      // 2. Fetch product categories (real-time)
      const q11 = query(collection(db, 'productcats'));
      onSnapshot(q11, (querySnapshot) => {
        setproductCat(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      // 3. Fetch product units once (not real-time)
      const unitSnap = await getDocs(collection(db, 'productunits'));
      const unitMap = {};
      unitSnap.forEach(doc => {
        unitMap[doc.id] = doc.data().unit;
      });

      // 4. Fetch products (real-time) and map unit name from cache
      const q1 = query(collection(db, 'products'), orderBy("created", "desc"));
      onSnapshot(q1, (querySnapshot1) => {
        const combinedData = querySnapshot1.docs.map((doc1) => {
          const data = doc1.data();
          const unitId = data.unit;
          const unit = unitMap[unitId] || "";

          return {
            id: doc1.id,
            data: data,
            unit: unit
          };
        });

        setproducts(combinedData);
      });

    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message
      });
    }
  };


  const fetchData2 = async () => {
    try {
      if (productCat) {
        const filteredData = products.filter((item) =>
          item.data.date.toUpperCase().includes(searchText.toUpperCase())
        );
        setproducts(filteredData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleSubmit = async () => {
    if (!date) {
      Toast.fire({ icon: "error", title: "Please select date" });
      return;
    }

    const cdate = new Date(date);
    const prevDate = moment(cdate.setDate(cdate.getDate() - 1)).format("YYYY-MM-DD");

    // Check if report already exists
    const existingSnap = await getDocs(query(collection(db, "excisereport"), where("date", "==", date)));
    if (!existingSnap.empty) {
      Toast.fire({ icon: "error", title: `Excise Report already generated for ${date}` });
      return;
    }

    // Create new excise report
    const docRef = await addDoc(collection(db, "excisereport"), {
      date,
      status: "Active",
      uid: userData.uid,
      created: Timestamp.now(),
    });

    if (!products || products.length === 0) return;

    await Promise.all(
      products.map(async (item) => {
        const productId = item.id;
        const prodName = item.data.prodname;
        const unitId = item.data.unit;
        const defaultStock = item.data.stock || 0;

        // Opening stock
        let ropeningstock = 0;
        const openingq = query(
          collection(db, "excisestock"),
          where("productid", "==", productId),
          where("date", "==", prevDate)
        );
        const openingSnap = await getDocs(openingq);

        if (!openingSnap.empty) {
          const agg = await getAggregateFromServer(openingq, {
            openingstock: sum("closingunitstock"),
          });
          ropeningstock = agg.data().openingstock || 0;
        } else {
          await addDoc(collection(db, "excisestock"), {
            excisereportid: "",
            date: prevDate,
            prodname: prodName,
            productid: productId,
            unitid: unitId,
            openingunitstock: defaultStock,
            purchaseunitstock: 0,
            saleunitstock: 0,
            closingunitstock: defaultStock,
            uid: userData.uid,
            created: Timestamp.now(),
          });
          ropeningstock = defaultStock;
        }

        // Purchase stock
        let rpurchasestock = 0;
        const purchaseq = query(
          collection(db, "purchasesitems"),
          where("itemid", "==", productId),
          where("status", "==", "Active"),
          where("purchaseDate", "==", date)
        );
        const purchaseSnap = await getDocs(purchaseq);
        if (!purchaseSnap.empty) {
          const agg = await getAggregateFromServer(purchaseq, {
            qty: sum("qty"),
          });
          rpurchasestock = agg.data().qty || 0;
        }

        // Sale stock
        let rsalestock = 0;
        const saleq = query(
          collection(db, "orderitems"),
          where("itemid", "==", productId),
          where("orderdate", "==", date)
        );
        const saleSnap = await getDocs(saleq);
        if (!saleSnap.empty) {
          const agg = await getAggregateFromServer(saleq, {
            quantity: sum("quantity"),
          });
          rsalestock = agg.data().quantity || 0;
        }

        const rclosingstock = parseFloat(ropeningstock) + parseFloat(rpurchasestock) - parseFloat(rsalestock);

        // Add final stock entry
        await addDoc(collection(db, "excisestock"), {
          excisereportid: docRef.id,
          date,
          prodname: prodName,
          productid: productId,
          unitid: unitId,
          openingunitstock: ropeningstock,
          purchaseunitstock: rpurchasestock,
          saleunitstock: rsalestock,
          closingunitstock: rclosingstock,
          uid: userData.uid,
          created: Timestamp.now(),
        });
      })
    );

    setdate("");
    Toast.fire({ icon: "success", title: "Excise Report Successfully Generated!" });
  };



  const handleDelete = async (docid) => {
    try {
      // Delete the main report
      await deleteDoc(doc(db, "excisereport", docid));

      // Get and delete all excisestocks linked to this report
      const stockSnap = await getDocs(
        query(collection(db, "excisestock"), where("excisereportid", "==", docid))
      );

      await Promise.all(
        stockSnap.docs.map((doc) => deleteDoc(doc.ref))
      );

      Toast.fire({
        icon: "success",
        title: "Excise Report Deleted Successfully!",
      });

      fetchData1();
    } catch (error) {
      console.error("Delete Error:", error);
      Toast.fire({ icon: "error", title: error.message });
    }
  };

  const printReport = async (docid, rdate) => {
    try {
      setreportdate(rdate);
      setreportData([]);

      // Step 1: Fetch excise stock records for selected date
      const q1 = query(
        collection(db, 'excisestock'),
        where('date', '==', rdate),
        orderBy('prodname', 'asc')
      );
      const querySnapshot = await getDocs(q1);

      // Step 2: Load all product units once into a map
      const unitSnap = await getDocs(collection(db, 'productunits'));
      const unitMap = {};
      unitSnap.forEach((doc) => {
        const data = doc.data();
        if (doc.id && data?.unit) {
          unitMap[doc.id] = data.unit;
        }
      });

      // Step 3: Map excise stock docs into final report array
      const combinedData = querySnapshot.docs.map((doc1) => {
        const docData = doc1.data();

        // Validate docData
        if (!docData || typeof docData !== 'object') return null;

        // Safely access unit ID and fetch unit from unitMap
        const unitid = typeof docData.unitid === 'string' ? docData.unitid : "";
        const unit = unitMap[unitid] || "";

        return {
          id: doc1.id,
          data: docData,
          unit: unit,
        };
      }).filter(Boolean); // Remove any nulls

      // Step 4: Set final report data
      setreportData(combinedData);
      console.log("Report data:", combinedData);
    } catch (error) {
      console.error("Error generating report:", error);
      Toast.fire({
        icon: "error",
        title: "Failed to generate report: " + error.message,
      });
    }
  };


  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " onClick={() => handleSubmit()} style={{ float: "right" }} >|| Excise Report ||</button>
            <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Generate Report</button><br /><br />
            <div className="card card-primary card-outline ex1">
              <div className=" p-1">
                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
              </div>
              <div className="card-body table-responsive p-0" >
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      exisereports.map((item, index) =>
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td> {moment(item.data.date).format('DD-MM-YYYY')}</td>
                          <td>
                            <a onClick={() => printReport(item.id, item.data.date)} className="btn btn-sm btn-success" href='#0' data-toggle="modal" data-target="#text-modal1" > <i className="fa fa-print"></i></a>&nbsp;
                            <a onClick={() => handleDelete(item.id)} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>
                          </td>
                        </tr>)
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ============================================= modal start ================================================= */}

      <div className="modal fade" id="insert-modal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Generate Excise Report</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <label>  Date </label>
                  <input type="date" value={date} onChange={(e) => setdate(e.target.value)} className="form-control" />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="submit" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Generate Report </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="text-modal1">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Print Exise Report</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className='row p-3' >
                <div className='col-sm-4'>
                  <span>Name of the License</span>
                  <h6>PRATIK BAR & RESTO</h6>
                </div>
                <div className='col-sm-4'>
                  {/* <h4>FORM F.L.R. 1A/2A/3A</h4> */}
                </div>
                <div className='col-sm-4'>
                  <span>Date</span>
                  <h6>{moment(reportdate).format('DD/MM/YYYY')}</h6>
                </div>
              </div><hr />
              <table className='customers2'>
                <tr>
                  <th><label>Item</label></th>
                  <th><label>Opeing Balance</label></th>
                  <th><label>Purchase Stock</label></th>
                  <th><label>Sale Stock</label></th>
                  <th><label>Closing Balance</label></th>
                </tr>
                {
                  reportData.map((item, index) =>
                    <tr key={index}>
                      <td>{item.data.prodname} {item.unit} </td>
                      <td>{item.data.openingunitstock} </td>
                      <td>{item.data.purchaseunitstock} </td>
                      <td>{item.data.saleunitstock} </td>
                      <td>{item.data.closingunitstock} </td>
                    </tr>
                  )
                }
              </table>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}
